import { Box, Container, Typography } from "@mui/material";
import Footer from "../components/HomeComponent/Footer";
import { getResponsiveHeight } from "../utils/responsive";
import globalStyles from "../global";
import { useTranslation } from "react-i18next"; // Import useTranslation
import News from "../components/globalCountries/countryhomepagescomponent/News";
import FreeDeliveryBanner from "../components/HomeComponent/FreeDeliveryBanner";
const Privacy = () => {
  const { t } = useTranslation(); // Initialize useTranslation

  const renderGrievanceOfficer = () => (
    <Box sx={{ mt: 3 }}>
      <Typography
        sx={{
          fontFamily: "'Poppins'",
          fontWeight: 400,
          fontSize: {sm:"20px",xs:"16px"},
          lineHeight: "28px",
          letterSpacing: "0%",
          textAlign: "justify",
          color: "#4d4d4d",
          mb: "30px",
        }}
      >
        {t("privacy.grievanceOfficerDescription")}
      </Typography>

      <Typography
        sx={{
          fontFamily: "'Poppins'",
          fontWeight: 600,
           fontSize: {md:"30px",sm:"24px",xs:"20px"},
          lineHeight: "32px",
          letterSpacing: "0%",
          textAlign: "justify",
          color: globalStyles.colors.army_green,
          mb: 2,
        }}
      >
        {t("privacy.grievanceOfficerName")}
      </Typography>

      <Typography
        sx={{
          ffontFamily: "'Poppins'",
          fontWeight: 400,
         fontSize: {sm:"20px",xs:"16px"},
          lineHeight: "28px",
          letterSpacing: "0%",
          color: "#4d4d4d",
          mb: "30px",
        }}
      >
        {t("privacy.grievanceOfficerAddress")}
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            component="img"
            src="/phone.png"
            alt="phone"
            sx={{ width: 16, height: 16 }}
          />
          <Typography
            sx={{
              fontFamily: "'Poppins'",
              fontWeight: 400,
               fontSize: { sm: "18px", xs: "14px" },
              lineHeight: "100%",
              letterSpacing: "0%",
              textAlign: "justify",
              color: "#4d4d4d",
            }}
          >
            {t("privacy.phoneNumber")}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            component="img"
            src="/time.png"
            alt="time"
            sx={{ width: 16, height: 16 }}
          />
          <Typography
            sx={{
              fontFamily: "'Poppins'",
              fontWeight: 400,
               fontSize: { sm: "16px", xs: "12px" },
              lineHeight: "100%",
              letterSpacing: "0%",
              textAlign: "justify",
              color: "#4d4d4d",
            }}
          >
            {t("privacy.time")}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            component="img"
            src="/mail.png"
            alt="email"
            sx={{ width: 16, height: 16 }}
          />
          <Typography
            sx={{
              fontFamily: "'Poppins'",
              fontWeight: 400,
              fontSize: { sm: "16px", xs: "12px" },
              lineHeight: "100%",
              letterSpacing: "0%",
              textAlign: "justify",
              color: "#4d4d4d",
            }}
          >
            {t("privacy.email")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  const privacyContent = [
    {
      title: "collectionOfPersonalDetailsTitle",
      content: "collectionOfPersonalDetailsContent",
    },
    {
      title: "useOfDemographicDataTitle",
      content: "useOfDemographicDataContent",
    },
    {
      title: "sharingOfPersonalInformationTitle",
      content: "sharingOfPersonalInformationContent",
    },
    {
      title: "linksToOtherSitesTitle",
      content: "linksToOtherSitesContent",
    },
    {
      title: "securityPrecautionsTitle",
      content: "securityPrecautionsContent",
    },
    {
      title: "choiceOptOutTitle",
      content: "choiceOptOutContent",
    },
    {
      title: "advertisementsTitle",
      content: "advertisementsContent",
    },
    {
      title: "yourConsentTitle",
      content: "yourConsentContent",
    },
  ];
  const styles = {
    heroContainer: {
      width: "100%",
      height: { sm: "500px", xs: "400px" },
      position: "relative",
      overflow: "hidden",
    },
    heroImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 1,
    },
    heroContent: {
      position: "relative",
      zIndex: 2,
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "start",
      maxWidth: "1200px",
      mx: "auto",
      width: "100%",
      px: 2,
    },
    heroTitle: {
      fontFamily: "AllRoundGothicBold",
      fontWeight: 400,
      lineHeight: "60px",
      letterSpacing: "1%",
      textTransform: "uppercase",
     fontSize: {
                md: "55px",
                sm: "36px",
                xs: "30px",
              },
      color: "#174C2E",
      maxWidth: "770px",
      // fontFamily: "AllRoundGothicBold",
      // fontWeight: 700,

      // lineHeight: 1.1,
      // letterSpacing: "1%",
      // textTransform: "uppercase",

      // width: {
      //   xs: "50%",
      //   sm: "60%",
      //   md: "480px",
      // },

      // height: {
      //   xs: "auto",
      //   md: "80px",
      // },

      // position: "absolute",

      // top: {
      //   xs: "40px",
      //   sm: "70px",
      //   md: "75px",
      // },

      // left: {
      //   xs: "20px",
      //   sm: "20px",
      //   md: "129px",
      // },

      // right: {
      //   xs: "auto",
      //   sm: "auto",
      //   md: "auto",
      // },

      // textAlign: {
      //   xs: "left",
      //   sm: "left",
      //   md: "left",
      // },

      // color: "#174C2E",

      // fontSize: {
      //   xs: getResponsiveSize(32),
      //   md: getResponsiveSize(38),
      //   lg: getResponsiveSize(45),
      // },
    },
  };

  return (
    <Box>
      <Box sx={styles.heroContainer}>
        <Box
          component="img"
          src={`${process.env.REACT_APP_IMAGE_BASE_URL}privacyBanner.svg`}
          alt="Privacy Banner"
          sx={styles.heroImage}
        />
        <Container
          maxWidth="1200px"
          sx={{ height: "100%", position: "relative" }}
        >
          <Box sx={styles.heroContent}>
            <Typography sx={styles.heroTitle}>
              {t("privacy.privacyPolicyTitle")}
            </Typography>
          </Box>
        </Container>
      </Box>

      <Container>
        <Box
          sx={{
            // marginTop: {
            //   xs: getResponsiveHeight(4),
            //   sm: getResponsiveHeight(6),
            //   md: getResponsiveHeight(12),
            // },
            // width: { xs: "100%", sm: "96%", md: "80%", lg: "75%" },
            // margin: "0 auto",
            fontFamily: "'Poppins'",
            fontWeight: 400,
            fontSize: {sm:"20px",xs:"16px"},
            lineHeight: "30px",
            letterSpacing: "0%",
            textAlign: "justify",
            color: "#4d4d4d",
            width: "100%",
            maxWidth: "1200px",
            mx: "auto",
            mt: 8,
            py: 8,
            px: {
              xs: 1,
              sm: 0,
            },
          }}
        >
          <Typography
            sx={{
              fontFamily: "'Poppins'",
              fontWeight: 400,
              fontSize: {sm:"20px",xs:"16px"},
              lineHeight: "28px",
              letterSpacing: "0%",
              textAlign: "justify",
              color: "#4d4d4d",
              mb: 6,
            }}
          >
            {t("privacy.introduction")}
          </Typography>
          <hr className="pb-12" />
          <Typography
            sx={{
              color: globalStyles.colors.army_green,
              fontFamily: "AllRoundGothicBold",
              fontWeight: 400,
              lineHeight: "100%",
              letterSpacing: "1%",
              textTransform: "uppercase",
              fontSize: {md:"40px",sm:"38px", xs:"24px"},
              mb: 2.5,
            }}
          >
            {t("privacy.importantNotes")}
          </Typography>
          <Typography
            sx={{
              fontFamily: "'Poppins'",
              fontWeight: 400,
             fontSize: {sm:"20px",xs:"16px"},
              lineHeight: "28px",
              letterSpacing: "0%",
              textAlign: "justify",
              color: "#4d4d4d",
              mb: "30px",
            }}
          >
            {t("privacy.notesContent")}
          </Typography>

          {privacyContent.map((item, index) => (
            <Box
              key={index}
              sx={{
                marginTop: {
                  xs: getResponsiveHeight(1.5),
                  sm: getResponsiveHeight(2),
                  md: getResponsiveHeight(2),
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "'Poppins'",
                  fontWeight: 600,
                  fontSize: {md:"30px",sm:"24px",xs:"20px"},
                  lineHeight: "32px",
                  letterSpacing: "0%",
                  textAlign: "justify",
                  color: globalStyles.colors.army_green,
                  mb: 2,
                }}
              >
                {index + 1}. {t(`privacy.${item.title}`)}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "'Poppins'",
                  fontWeight: 400,
                 fontSize: {sm:"20px",xs:"16px"},
                  lineHeight: "28px",
                  letterSpacing: "0%",
                  textAlign: "justify",
                  color: "#4d4d4d",
                  mb: "30px",
                }}
              >
                {t(`privacy.${item.content}`)}
              </Typography>
            </Box>
          ))}

          <Typography
            sx={{
              fontFamily: "'Poppins'",
              fontWeight: 600,
              fontSize: "24px",
              lineHeight: "32px",
              letterSpacing: "0%",
              textAlign: "justify",
              color: globalStyles.colors.army_green,
              mb: 2,
            }}
          >
            9. {t("privacy.grievanceOfficerTitle")}
          </Typography>
          {renderGrievanceOfficer()}
        </Box>
        <hr className="pb-8" />
      </Container>
      <FreeDeliveryBanner />
      <News />
      <Box sx={{ height: "80px" }} />
      <Footer />
    </Box>
  );
};

export default Privacy;
